import moment from 'moment';

export default function(time, now, clamp, short) {
  if (!time) return '';
  time = moment.utc(time);
  now = moment.utc(now);
  if (clamp && time > now) time = now;
  if (!time.isValid()) return '';
  if (!short) return time.local().from(now);
  return time.local().from(now);
}
